query BudgetListCommonData {
  
  companyCurrencies {
    nodes {
      id
      name
      isoCode
    }
  }
  companyBusinessUnits (orderBy: NAME_ASC){
    nodes {
      id
      name
    }
  }
   userDepartments(
    orderBy: COMPANY_DEPARTMENT_BY_ID__NAME_ASC,
    filter: {_isUserAdministrator: {equalTo: true}}
  ) {
    nodes {
      id
      userDepartment{
        name
      }
    }
  }
   departmentBudgetTypes
  {
    nodes{
    id
    budgetType
    }
  }
 
}
